import { useState } from 'react';
import './TokiPona.scss';
import Button from '../../components/Button/Button';
import Menu from '../../components/Menu/Menu';

export default function TokiPona() {
    return (
        <div id="tokipona">
            <div className='centered-container'>
                <Menu title="Toki Pona" options={[
                    { name: 'Sitelen Pona', path: '/tokipona/alphabet' },
                    { name: 'Sitelen Pona Quiz', path: '/tokipona/sitelen/quiz' },
                ]} />
            </div>
        </div>
    );
}